export enum AiFloatReportPlace {
    startTab = '0',
    insertTab = '1',
    singleTab = '2',
    aiTab = '3',
    thumbnail = '4'
}
